module.exports = __webpack_public_path__ + "static/header_picture-6147aaf130b80f6a890110a8b4f10cdc.webp";